let quotationEnvironmentsApi = {
    async get(token, companyId, params = {}) {
        let response = await window.axios.get('/api/quotation-environments', {
            params: {
                api_token: token,
                company_logged: companyId,
                ...params
            }
        });
        return response.data;
    },
    async delete(token, companyId, id) {
        let response = await window.axios.delete('/api/quotation-environments/' + id, {
            params: {
                api_token: token,
                company_logged: companyId,
            }
        });
        return response.data;
    },
    async save(token, companyId, data) {
        let response = await window.axios.post('/api/quotation-environments', {
            api_token: token,
            company_id: companyId,
            ...data
        });
        return response.data;
    }
};

export default quotationEnvironmentsApi;
